export default __webpack_public_path__ + "static/media/100_6207.56f9e954.jpg";